/**
 * Providers Component
 * 
 * Wraps the app with necessary providers:
 * - Apollo Client (GraphQL)
 * - SafeMotionProvider (SSR-safe animations)
 */

import { type ReactNode, useMemo } from 'react';
import { ApolloProvider, createApolloClient } from '@bloomcode/apollo';
import { SafeMotionProvider } from './components/ui/SafeMotion';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  // Create Apollo client lazily to avoid SSR issues
  const apolloClient = useMemo(() => createApolloClient({
    graphqlEndpoint: import.meta.env.VITE_GATEWAY_URL || 'https://api.dev.bloomcodetechnologies.online/graphql',
    appId: import.meta.env.VITE_APP_ID,
  }), []);

  return (
    <ApolloProvider client={apolloClient}>
      <SafeMotionProvider>
        {children}
      </SafeMotionProvider>
    </ApolloProvider>
  );
}
